import SchoolsPartnersAdd from "./SchoolsPartnersAdd";

export default SchoolsPartnersAdd;
